import { render, staticRenderFns } from "./AuthorizationsCreatePage.vue?vue&type=template&id=9a98a74e&"
import script from "./AuthorizationsCreatePage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsCreatePage.vue?vue&type=style&index=0&language=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports